import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';

const initialState = {
    secondSsidNetwork: {},
    secondSsidNetworkSuccess: false,
    secondSsidNetworkFail: false,
    secondSsidNetworkLoading: false,
    secondSsidFailureMesssage: '',
    secondSsidDeleteFailureMesssage: '',
    secondSsidNetworkSuccessMessage: ''
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_SECOND_SSID_LOADING:
            return updateObject(state, {
                secondSsidNetwork: {},
                secondSsidNetworkLoading: true
            });
        case actionTypes.GET_SECOND_SSID_SUCCESS:
            return updateObject(state, {
                secondSsidNetwork: action.payload?.network || {},
                secondSsidNetworkLoading: false
            });
        case actionTypes.GET_SECOND_SSID_FAIL:
            return updateObject(state, {
                secondSsidNetwork: {},
                secondSsidNetworkFail: true,
                secondSsidNetworkLoading: false
            });
        case actionTypes.SET_SECOND_SSID_INFO:
            return updateObject(state, {
                secondSsidNetworkLoading: false,
                secondSsidNetwork: action.info?.network,
                secondSsidNetworkSuccess: true,
                secondSsidNetworkFail: false
            });
        case actionTypes.SET_SECOND_SSID_INFO_FAIL:
            return updateObject(state, {
                secondSsidNetworkFail: true,
                secondSsidNetworkSuccess: false
            });
        case actionTypes.SET_SECOND_SSID_INFO_SUCCESS:
            return updateObject(state, {
                secondSsidNetworkSuccess: true,
                secondSsidNetworkFail: false
            });
        case actionTypes.SET_SECOND_SSID_INFO_FAIL_MESSAGE:
            return updateObject(state, {
                secondSsidFailureMesssage:action.info,
            });
        case actionTypes.DELETE_SECOND_SSID_INFO_SUCCESS: 
        return updateObject(state, {
            secondSsidNetworkSuccess: true,
            secondSsidNetwork: {},
            secondSsidNetworkFail: false,
            secondSsidNetworkSuccessMessage: 'Guest WiFi successfully deleted'
        });
        case actionTypes.DELETE_SECOND_SSID_INFO_FAILED: 
        return updateObject(state, {
            secondSsidNetworkSuccess: false,
            secondSsidNetworkFail: true,
            secondSsidNetworkSuccessMessage: '',
            secondSsidDeleteFailureMesssage: 'There was an issue removing the Guest WiFi, please try again in a moment.'
        });
        case actionTypes.RESET_SECOND_SSID_ERROR_SUCCESS:
            return updateObject(state , {
                secondSsidNetworkSuccess: false,
                secondSsidNetworkFail: false,
                secondSsidNetworkSuccessMessage: '',
                secondSsidDeleteFailureMesssage: '',
                secondSsidFailureMesssage: ''
                });
     
        default: return state;
    }
};
export default reducer;

